'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _styles = require('./styles.css');

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } // Theirs.


// Ours.


var Notice = function Notice(_ref) {
  var error = _ref.error,
      primaryMessage = _ref.primaryMessage,
      secondaryMessage = _ref.secondaryMessage;

  var classNames = (0, _classnames2.default)(_styles2.default.notice, _defineProperty({}, _styles2.default['notice--error'], error));
  return _react2.default.createElement(
    'div',
    { className: classNames },
    _react2.default.createElement(
      'span',
      { className: _styles2.default['notice__primary-message'] },
      primaryMessage
    ),
    _react2.default.createElement(
      'span',
      { className: _styles2.default['notice__secondary-message'] },
      secondaryMessage
    )
  );
};

Notice.propTypes = {
  error: _react.PropTypes.bool,
  primaryMessage: _react.PropTypes.node.isRequired,
  secondaryMessage: _react.PropTypes.node
};

Notice.defaultProps = {
  error: false
};

exports.default = Notice;